"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasuringMachines = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const MeasuringMachines = ({ fill = "#E6E6E6", size = 32 }) => (react_1.default.createElement(Base_1.Base, { smooth: true, fill: "none", size: size, viewBox: "0 0 32 32" },
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { fill: fill, opacity: "0", d: "M0,0L32,0 32,32 0,32 0,0z" }),
        react_1.default.createElement("path", { fill: fill, opacity: "1", d: "M10,11L10,21 22,21 22,11 10,11z M5.99999952316284,7.00000047683716L26,7.00000047683716 26,11 24,11 24,21 26,21 26,27 5.99999952316284,27 5.99999952316284,21 7.99999952316284,21 7.99999952316284,11 5.99999952316284,11 5.99999952316284,7.00000047683716z" }),
        react_1.default.createElement("path", { fill: fill, opacity: "1", d: "M15,2.00000047683716L17,2.00000047683716 17,15C17,15.5,16.5999984741211,16,16.0999984741211,16L13.6999969482422,18.3999996185303 13,17.7000007629395 15.1999969482422,15.5C15.0999984741211,15.3000001907349,15,15.1999998092651,15,15L15,2.00000047683716z" }))));
exports.MeasuringMachines = MeasuringMachines;
//# sourceMappingURL=MeasuringMachines.js.map